import React from "react"
import PropTypes from "prop-types"

import { CreateModal } from "@components/Page"
import { useAppContext } from "@components/AppContext"
import { getFormSchema, TYPE_NONE, TYPE_DOMAIN } from "@components/Form"

const createOperation = "organizations/CreateOrganization"

const getCreateSchema = getFormSchema(createOperation)
const schema = getCreateSchema([
  {
    name: "name",
    placeholder: "Organization Name",
  },
    {
      name: "domain",
      type: TYPE_DOMAIN,
      inputProps: {
        placeholder: "subdomain",
        style: { textAlign: "right" },
      }
    },

  {
    name: "email",
    required: true,
    placeholder: "example@host.com",
  },
  {
    name: "logoUrl",
    type: TYPE_NONE,
  }
])

const LABEL_ADD = "New Organization"
const LABEL_ENTITY = "Organization"


const OrganizationCreateModal = ({
  modal,
  table,
  onSuccess: onSuccessCustom
}) => {
  const { authenticatedRequest } = useAppContext()

  const onSuccess = () => onSuccessCustom()

  return (
    <CreateModal
      modal={modal}
      title={LABEL_ADD}
      entity={LABEL_ENTITY}
      schema={schema}
      request={authenticatedRequest}
      onSuccess={onSuccess}
      operation={createOperation}
      table={table}
    />
  )
}

OrganizationCreateModal.propTypes = {
  modal: PropTypes.shape().isRequired,
  onSuccess: PropTypes.func.isRequired,
  table: PropTypes.shape().isRequired,
}

export default OrganizationCreateModal
